import { ROUTE } from "../../routes";
import sharedPropsService from "../../SharedPropsService";
export const ClosePopup = async (action, _datastore, { goBack, setDatastore }) => {
    await setDatastore(ROUTE.ALERT_PAGE, "alert", {
        loading: false
    });
    await sharedPropsService.setRegisterLeadButtonActive(true);
    await goBack();
};
